module.exports = __webpack_public_path__ + "static/media/stethoscope.9de0439e.svg";